/**
 * Carregado quando new.html.erb for renderizado
 */

import { URLParamsReader } from './utils/url_params_reader';
import { cleanupExpiredUTM, saveUTMParams } from './utils/cookie_manager';

document.addEventListener('DOMContentLoaded', function() {
  // Cleanup de cookies UTM expirados
  cleanupExpiredUTM();
  
  const urlReader = new URLParamsReader();
  
  // COMPRI - Capturar parâmetros UTM para analytics
  const utmParams = urlReader.getUTMParams();
  
  // Sempre salva parâmetros UTM no cookie _pm3_utm (preservando valores existentes quando URL vem em branco)
  saveUTMParams(utmParams);
});